"use client"
import React, { useState, useRef, useEffect } from "react"
import { ChevronDown, ChevronRight } from "lucide-react"

type FAQ = {
  id: number
  question: string
  answer: string
}

interface FAQSectionProps {
  title?: string
  faqs: FAQ[]
  className?: string
}

const FAQSection = ({ title, faqs, className }: FAQSectionProps) => {
  const [activeId, setActiveId] = useState<number | null>(null)
  const [heights, setHeights] = useState<{ [key: number]: number }>({})
  const contentRefs = useRef<{ [key: number]: HTMLDivElement | null }>({})

  const toggleFAQ = (id: number) => {
    setActiveId(activeId === id ? null : id)
  }

  useEffect(() => {
    // Calculate heights for each FAQ content
    const newHeights: { [key: number]: number } = {}
    faqs.forEach(faq => {
      const element = contentRefs.current[faq.id]
      if (element) {
        newHeights[faq.id] = element.scrollHeight
      }
    })
    setHeights(newHeights)
  }, [faqs])

  return (
    <section className={`faq-section ${className || ''}`}>
      <div className="section-container">
        {title && <h2 className="section-heading">{title}</h2>}

        <div className="faq-list">
          {faqs.map((item) => {
            const isActive = activeId === item.id

            return (
              <div key={item.id} className={`faq-card ${isActive ? "active" : ""}`}>
                <div
                  className="faq-header"
                  onClick={() => toggleFAQ(item.id)}
                >
                  <h5 className="faq-question">{item.question}</h5>
                  <span className="faq-icon">
                    {isActive ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                  </span>
                </div>

                <div 
                  className={`faq-collapse ${isActive ? "show" : ""}`}
                  style={{
                    maxHeight: isActive ? `${heights[item.id] || 0}px` : '0px'
                  }}
                >
                  <div 
                    className="faq-body"
                    ref={(el) => {
                      if (el) {
                        contentRefs.current[item.id] = el
                      }
                    }}
                  >
                    <p dangerouslySetInnerHTML={{ __html: item.answer }}></p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FAQSection
